import { API_DICTIONARY, HTTP_METHODS } from 'constants/api'
import Fetcher from 'services/Fetcher'
import {
  TBankAccount,
  TBankAccountForm,
  TBankAccountsListRequest,
  TBankAccountsListResponse,
  TGetMoovTokenPayload,
  TGetMoovTokenResponse,
  TSetNewDefaultReceivableAccount,
  TVerifyDepositForm
} from './types'
import { NOTIFICATIONS } from 'constants/txt'
import { ResponseWithPagination } from 'constants/types'

const fetcher = new Fetcher({})

export const getMoovToken = async (
  moov_account_id: string,
  action_type?: string
) =>
  fetcher.request<TGetMoovTokenPayload, TGetMoovTokenResponse>({
    url: `${API_DICTIONARY.PAYMENTS}${API_DICTIONARY.MOOV}${API_DICTIONARY.OAUTH}${API_DICTIONARY.ACCESS}`,
    method: HTTP_METHODS.POST,
    data: {
      action_type: action_type ?? 'link_bank_account',
      moov_account_id
    }
  })

export const increasePendingCreationBankAccountsCounter = async (
  business_account_id: string
) =>
  fetcher.request<unknown, unknown>({
    url: `${API_DICTIONARY.PAYMENTS}${API_DICTIONARY.MOOV}${API_DICTIONARY.BUSINESS_ACCOUNT}${business_account_id}/${API_DICTIONARY.BANK_ACCOUNTS}${API_DICTIONARY.PENDING_CREATION}`,
    method: HTTP_METHODS.POST
  })

export const getBankAccountsList = async (
  business_account_id: string,
  data: TBankAccountsListRequest
) =>
  fetcher.request<TBankAccountsListRequest, TBankAccountsListResponse>({
    url: `${API_DICTIONARY.PAYMENTS}${API_DICTIONARY.MOOV}${API_DICTIONARY.BUSINESS_ACCOUNT}${business_account_id}/${API_DICTIONARY.BANK_ACCOUNTS}`,
    method: HTTP_METHODS.GET,
    ...data.params
  })

export const getBankAccountDetails = async (
  business_account_id: string,
  id: string
) =>
  fetcher.request<unknown, TBankAccount>({
    url: `${API_DICTIONARY.PAYMENTS}${API_DICTIONARY.MOOV}${API_DICTIONARY.BUSINESS_ACCOUNT}${business_account_id}/${API_DICTIONARY.BANK_ACCOUNTS}${id}`,
    method: HTTP_METHODS.GET
  })

export const updateBankAccountDetails = async (
  business_account_id: string,
  id: string,
  data: Partial<TBankAccountForm> & TSetNewDefaultReceivableAccount
) =>
  fetcher.request<
    Partial<TBankAccountForm> & TSetNewDefaultReceivableAccount,
    unknown
  >({
    url: `${API_DICTIONARY.PAYMENTS}${API_DICTIONARY.MOOV}${API_DICTIONARY.BUSINESS_ACCOUNT}${business_account_id}/${API_DICTIONARY.BANK_ACCOUNTS}${id}/`,
    method: HTTP_METHODS.PATCH,
    successMessage: data?.is_default
      ? NOTIFICATIONS.BANK_ACCOUNT_SET_AS_DEFAULT_SUCCESSFULLY
      : NOTIFICATIONS.BANK_ACCOUNT_DETAILS_UPDATED,
    data
  })

export const sendDeposit = async (
  businessAccountId: string,
  bankAccountId: string
) =>
  fetcher.request<unknown, unknown>({
    url: `${API_DICTIONARY.PAYMENTS}${API_DICTIONARY.MOOV}${API_DICTIONARY.BUSINESS_ACCOUNT}${businessAccountId}/${API_DICTIONARY.BANK_ACCOUNTS}${bankAccountId}/${API_DICTIONARY.MICRO_DEPOSITS}`,
    method: HTTP_METHODS.POST,
    successMessage: NOTIFICATIONS.DEPOSIT_SENT
  })

export const deleteBankAccountDetails = async (
  id: string,
  business_account_id: string,
  data?: TSetNewDefaultReceivableAccount
) =>
  fetcher.request<unknown, TBankAccount>({
    url: `${API_DICTIONARY.PAYMENTS}${API_DICTIONARY.MOOV}${API_DICTIONARY.BUSINESS_ACCOUNT}${business_account_id}/${API_DICTIONARY.BANK_ACCOUNTS}${id}/`,
    method: HTTP_METHODS.DELETE,
    data
  })

export const verifyDeposit = async (
  businessAccountId: string,
  bankAccountId: string,
  data: TVerifyDepositForm
) =>
  fetcher.request<unknown, unknown>({
    url: `${API_DICTIONARY.PAYMENTS}${API_DICTIONARY.MOOV}${API_DICTIONARY.BUSINESS_ACCOUNT}${businessAccountId}/${API_DICTIONARY.BANK_ACCOUNTS}${bankAccountId}/${API_DICTIONARY.MICRO_DEPOSITS}${API_DICTIONARY.COMPLETE}`,
    method: HTTP_METHODS.POST,
    successMessage: NOTIFICATIONS.BANK_ACCOUNT_VERIFIED_SUCCESSFULLY,
    data
  })

export const getListOfAvailableAccountsToSetAsDefault = async (
  businessAccountId: string,
  bankAccountId: string
) =>
  fetcher.request<unknown, ResponseWithPagination<TBankAccount>>({
    url: `${API_DICTIONARY.PAYMENTS}${API_DICTIONARY.MOOV}${API_DICTIONARY.BUSINESS_ACCOUNT}${businessAccountId}/${API_DICTIONARY.BANK_ACCOUNTS}${bankAccountId}/${API_DICTIONARY.OPTIONS}${API_DICTIONARY.DEFAULT}`,
    method: HTTP_METHODS.GET
  })
